import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import styles from './index.module.scss';

import KeyValueCards from './KeyValueCards';
import PresentEnachCard from './PresentEnachCard';
import { RootState } from 'src/store';
import { createKey } from 'src/utils/CaseDetail.utils';
import { ENACH_MANDATE_STATUSES } from '../../interfaces/CaseDetail.type';
import { displayItems } from '../../constants/EmiSchedule.constant';
import { getEnachPresentDetails } from '../../actions/EmiScheduleActions';
import EnachValueCard from './EnachValueCard';
import { getMonth } from 'src/utils/DateHelper';

const failureStatuses = [
  ENACH_MANDATE_STATUSES.FAILED,
  ENACH_MANDATE_STATUSES.DISABLED,
  ENACH_MANDATE_STATUSES.SIGNED
];

const MAX_ENACH_PRESENT = 3;

const HeaderSection: React.FC<React.PropsWithChildren> = () => {
  const {
    loanId = '',
    customerId = '',
    caseBusinessVertical = '',
    caseReferenceId = ''
  } = useParams();

  const dispatch = useDispatch();
  const details = useSelector(
    (state: RootState) => state.caseDetail.pageData?.[createKey(loanId, customerId)]?.details?.data
  );
  const monthlyEnach = useSelector(
    (state: RootState) =>
      state.caseDetail.pageData?.[createKey(loanId, customerId)]?.monthlyEnach?.data
  );
  useEffect(() => {
    if (!monthlyEnach)
      dispatch(getEnachPresentDetails(customerId, loanId, caseReferenceId, caseBusinessVertical));
  }, [loanId, customerId]);

  const enachPresented = monthlyEnach?.enachHistory?.length || 0;
  const enachPresentMonth = monthlyEnach?.month ?? '';
  const emiCard = useMemo(
    () =>
      displayItems.map(item => {
        return (
          <KeyValueCards
            key={item.header}
            header={item.header}
            color={item.color}
            value={item.value}
            checkPluralization={item.checkPluralization}
          />
        );
      }),
    [details]
  );
  return (
    <div className={styles.headerSection}>
      {emiCard}
      {failureStatuses.some(status => status === details?.mandateStatus) ? (
        <PresentEnachCard />
      ) : (
        <div>
          <EnachValueCard
            key={'Enach'}
            header={`Auto pay presented for`}
            boldPart={enachPresentMonth}
            color={'black'}
            value={`${enachPresented}/${Math.max(MAX_ENACH_PRESENT, enachPresented)}`}
            monthlyEnach={monthlyEnach?.enachHistory}
          />
        </div>
      )}
    </div>
  );
};

export default HeaderSection;
